import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { SurveySelectionDialogData } from '../dialogs-data/survey-selection-dialog-data';
import { SurveySelectionDialogComponent } from '../dialogs/survey-selection-dialog/survey-selection-dialog.component';

@Injectable()
export class SurveySelectionDialogService {
    constructor(
        private dialog: MatDialog, 
        private httpClient: HttpClient
    ) { }
    matDialogRef: MatDialogRef<SurveySelectionDialogComponent>;

    open(surveySelectionDialogData: SurveySelectionDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '30%';
        matDialogConfig.data = surveySelectionDialogData;
        matDialogConfig.disableClose = false;
        matDialogConfig.hasBackdrop = true;

        this.matDialogRef = this.dialog.open(SurveySelectionDialogComponent, matDialogConfig);

        if (this.matDialogRef?.componentInstance) {
            this.matDialogRef.componentInstance.surveySelectionDialogData = surveySelectionDialogData;
        }
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
